import React, { useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import AddressForm from "../Address";



function MainContactForm()  {
    //
    const [form, setForm] = useState({});
    //


    return (
        <>  
            {/* Main contact person:
                Title: Dr./Assoc. prof./Prof./Mr./Mrs./Ms. 
                Gender: Woman/Man/NonBinary
                First name: 
                Last name:
                e-mail:
                Position in org.
                Department:
                Street:
                Town: 
                Postcode:
                Country:
                Website:
                Phone: 
                Phone2: */}

            <Form.Group className="mb-3 " as={Row}>
                <Form.Label column sm={2}>Title</Form.Label>
                <Col sm={5}>
                <Form.Select aria-label="Default title">
                    
                    <option value="1">Dr.</option>
                    <option value="2">Asst. prof.</option>
                    <option value="3">Assoc. prof.</option>
                    <option value="4">Prof.</option>
                    <option value="5">Mr.</option>
                    <option value="6">Mrs.</option>
                    <option value="7">Ms.</option>
                </Form.Select>
                </Col>
            </Form.Group>

            <Form.Group className="mb-3" as={Row}>
                <Form.Label column sm={2} >Gender</Form.Label>
                <Col sm={5}>
                <Form.Select aria-label="Default title">
                    <option value="1">Male</option>
                    <option value="2">Female</option>
                    <option value="3">Non-binary</option>
                </Form.Select>
                </Col>
            </Form.Group>

            <Form.Group className="mb-3" as={Row}>
                <Form.Label column sm={2}>First name</Form.Label>
                <Col sm={5}>
                <Form.Control
                    value={form.first_name}
                    onChange={(e) => setForm({ ...form,
                        first_name: e.target.value })}
                    required
                    type="text"
                />
                </Col>
                <Form.Control.Feedback type="invalid">
                    This field is required.
                </Form.Control.Feedback>
            </Form.Group>
            
            <Form.Group className="mb-3" as={Row}>
                <Form.Label column sm={2}>Last name</Form.Label>
                <Col sm={5}>
                <Form.Control
                    value={form.last_name}
                    onChange={(e) => setForm({ ...form,
                        last_name: e.target.value })}
                    required
                    type="text"
                />
                </Col>
                <Form.Control.Feedback type="invalid">
                    This field is required.
                </Form.Control.Feedback>
            </Form.Group>
            

            <AddressForm />    
            
            {/*  Email */}
            <Form.Group className="mb-3" as={Row}>
                <Form.Label column sm={2}>E-mail</Form.Label>
                <Col sm={5}>
                <Form.Control
                    value={form.email}
                    onChange={(e) => setForm({ ...form, 
                        email:e.target.value })}
                    required
                    type="email"
                />
                </Col>
                <Form.Control.Feedback type="invalid">
                    Please provide a valid web page link.
                </Form.Control.Feedback>
            </Form.Group>


            <Form.Group className="mb-3" as={Row}>
                <Form.Label column sm={2}>Position in organization</Form.Label>
                <Col sm={5}>
                <Form.Control
                    value={form.position}
                    onChange={(e) => setForm({ ...form,
                         position: e.target.value })}
                    required
                    type="text"
                />
                </Col>
                <Form.Control.Feedback type="invalid">
                    This field is required.
                </Form.Control.Feedback>
            </Form.Group>


            <Form.Group className="mb-3" as={Row}>
                <Form.Label column sm={2}>Department</Form.Label>
                <Col sm={5}>
                <Form.Control
                    value={form.department}
                    onChange={(e) => setForm({ ...form,
                         department: e.target.value })}
                    required
                    type="text"
                />
                </Col>
                <Form.Control.Feedback type="invalid">
                    This field is required.
                </Form.Control.Feedback>
            </Form.Group>
            
            <AddressForm/>
            
            <Form.Group className="mb-3" as={Row}>
                <Form.Label column sm={2}>Website</Form.Label>
                <Col sm={10}>
                <Form.Control
                    value={form.website}
                    onChange={(e) => setForm({ ...form,
                         website: e.target.value })}
                    required
                    type="text"
                />
                </Col>
                <Form.Control.Feedback type="invalid">
                    This field is required.
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" as={Row}>
                <Form.Label column sm={2}>Phone</Form.Label>
                <Col sm={5}>
                <Form.Control
                    value={form.phone}
                    onChange={(e) => setForm({ ...form,
                         phone: e.target.value })}
                    required
                    type="text"
                />
                </Col>
                <Form.Control.Feedback type="invalid">
                    This field is required.
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" as={Row}>
                <Form.Label column sm={2}>Phone 2</Form.Label>
                <Col sm={5}>
                <Form.Control
                    value={form.phone2}
                    onChange={(e) => setForm({ ...form,
                         phone2: e.target.value })}
                    required
                    type="text"
                />
                </Col>
                <Form.Control.Feedback type="invalid">
                    This field is required.
                </Form.Control.Feedback>
            </Form.Group>

        </>
    );
}

export default MainContactForm;
            



            